module.exports = __webpack_public_path__ + "src/assets/images/logo_hero_color@2x.png?94fa66edbd563760a80113624952061e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_hero_color@2x.png
// module id = 1021
// module chunks = 1